import { useQuery } from "@tanstack/react-query";
import { listProjects } from "../api/projects";
import type { Project } from "../types";

export function useProjects(search?: string, enabled = true) {
  return useQuery<Project[]>({
    queryKey: ["projects", search ?? ""],
    queryFn: () => listProjects(search),
    enabled,
  });
}
